module.exports = __webpack_public_path__ + "static/media/1POLICY2.0f1c808c.jpg";